import { render, staticRenderFns } from "./red-bag.vue?vue&type=template&id=415a8586&scoped=true"
import script from "./red-bag.vue?vue&type=script&lang=js"
export * from "./red-bag.vue?vue&type=script&lang=js"
import style0 from "./red-bag.vue?vue&type=style&index=0&id=415a8586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415a8586",
  null
  
)

export default component.exports